import { showErrorToast } from '../toasts';

export default (message, toastId, timeout = 5000) => {
  showErrorToast(message, toastId);
  setTimeout(() => {
    window.location.assign('/');
  }, timeout);
};
